import { encodeURLSearchParams, mergeURLSegments } from '../../../SummaryBar/hooks/useParseTemplateLink';
import constructFromTemplate from '../../../CtaCard/constructFromTemplate';
function parseTemplateCtaLink(cta, tokenDictionary) {
    const url = mergeURLSegments(cta.href, cta.querystring);
    const href = encodeURLSearchParams(constructFromTemplate(url, tokenDictionary));
    const [base = '', search = ''] = href.split('?');
    return {
        href: base,
        hrefSearch: search,
        linkType: cta.linktype,
        styling: cta.styling.toLowerCase(),
    };
}
export default parseTemplateCtaLink;
